export const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
export const isMdUp = screenWidth >= 768;

export const isTouchDevice = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
